//imports
import CoreService from "npm-marsh-core/src/service/Service";

export default class Service extends CoreService 
{

    protected   vueActionUserUnAuthed = "AuthStore/authStoreDeleteAuth";

}